import { createContext } from 'react';

export interface UserMediaContextProps {
  stream?: MediaStream;
  error?: Error;
  askPermission: () => void;
}

export const UserMediaContext = createContext<
  UserMediaContextProps | undefined
>(undefined);
